var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScheduleSend = function SvgScheduleSend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "schedule_send_svg2__a",
    x1: -35.5,
    x2: 200.5,
    y1: 150.2,
    y2: 6.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#schedule_send_svg2__a",
    id: "schedule_send_svg2__b",
    x1: -42.7,
    x2: 193.2,
    y1: 138.3,
    y2: -5.7
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#schedule_send_svg2__a",
    id: "schedule_send_svg2__c",
    x1: -30.4,
    x2: 205.6,
    y1: 158.5,
    y2: 14.5
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#schedule_send_svg2__a",
    id: "schedule_send_svg2__d",
    x1: -20.5,
    x2: 215.5,
    y1: 174.7,
    y2: 30.7
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#schedule_send_svg2__a",
    id: "schedule_send_svg2__e",
    x1: -22.5,
    x2: 213.4,
    y1: 171.4,
    y2: 27.4
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#schedule_send_svg2__a",
    id: "schedule_send_svg2__f",
    x1: -10.9,
    x2: 225,
    y1: 190.4,
    y2: 46.3
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#schedule_send_svg2__a",
    id: "schedule_send_svg2__g",
    x1: 14.8,
    x2: 250.8,
    y1: 232.5,
    y2: 88.5
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#schedule_send_svg2__a",
    id: "schedule_send_svg2__h",
    x1: 13,
    x2: 248.9,
    y1: 229.6,
    y2: 85.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M90.6 168.2H22.7c-7.5 0-13.6-6.1-13.6-13.6V59.1h150v28.7c0 2.5 2 4.5 4.5 4.5s4.5-2 4.5-4.5V36.3c0-12.5-10.2-22.7-22.7-22.7h-9.1c0-7.5-6.1-13.6-13.6-13.6s-13.6 6.1-13.6 13.6h-50C59.1 6.1 53 0 45.5 0S31.9 6.1 31.9 13.6h-9.1C10.2 13.7 0 23.8 0 36.4v118.2c0 12.5 10.2 22.7 22.7 22.7h67.9c2.5 0 4.5-2 4.5-4.5s-2-4.5-4.5-4.5Zm27.6-154.6c0-2.5 2-4.5 4.5-4.5s4.5 2 4.5 4.5v9.1c0 2.5-2 4.5-4.5 4.5s-4.5-2-4.5-4.5zm-77.3 0c0-2.5 2-4.5 4.5-4.5s4.5 2 4.5 4.5v9.1c0 2.5-2 4.5-4.5 4.5s-4.5-2-4.5-4.5zM9.1 36.4c0-7.5 6.1-13.6 13.6-13.6h9.1c0 7.5 6.1 13.6 13.6 13.6S59 30.3 59 22.8h50c0 7.5 6.1 13.6 13.6 13.6s13.6-6.1 13.6-13.6h9.1c7.5 0 13.6 6.1 13.6 13.6V50H9.1z",
    style: {
      fill: "url(#schedule_send_svg2__a)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5 81.8c0-5-4.1-9.1-9.1-9.1H31.8c-5 0-9.1 4.1-9.1 9.1v13.6c0 5 4.1 9.1 9.1 9.1h13.6c5 0 9.1-4.1 9.1-9.1zM31.8 95.5V81.9h13.6v13.6z",
    style: {
      strokeWidth: 0,
      fill: "url(#schedule_send_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 81.8c0-5-4.1-9.1-9.1-9.1H77.3c-5 0-9.1 4.1-9.1 9.1v13.6c0 5 4.1 9.1 9.1 9.1h13.6c5 0 9.1-4.1 9.1-9.1zM77.3 95.5V81.9h13.6v13.6z",
    style: {
      strokeWidth: 0,
      fill: "url(#schedule_send_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.9 91.5c2.5 0 4.5-2 4.5-4.5v-5.2c0-5-4.1-9.1-9.1-9.1h-13.6c-5 0-9.1 4.1-9.1 9.1v13.1c0 2.5 2 4.5 4.5 4.5s4.5-2 4.5-4.5V81.8h13.6V87c0 2.5 2 4.5 4.5 4.5Z",
    style: {
      strokeWidth: 0,
      fill: "url(#schedule_send_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5 118.2H31.9c-5 0-9.1 4.1-9.1 9.1v13.6c0 5 4.1 9.1 9.1 9.1h13.6c5 0 9.1-4.1 9.1-9.1v-13.6c0-5-4.1-9.1-9.1-9.1m-13.7 22.7v-13.6h13.6v13.6z",
    style: {
      strokeWidth: 0,
      fill: "url(#schedule_send_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94 118.8c-1-.4-2.1-.6-3.1-.6H77.3c-5 0-9.1 4.1-9.1 9.1v13.6c0 5 4.1 9.1 9.1 9.1h9.3c2.5 0 4.5-2 4.5-4.5s-2-4.5-4.5-4.5h-9.3v-13.6h13.4c2.3.9 5-.3 5.9-2.6s-.2-4.9-2.5-5.9Z",
    style: {
      strokeWidth: 0,
      fill: "url(#schedule_send_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 100c-27.6 0-50 22.4-50 50s22.4 50 50 50 50-22.4 50-50-22.4-50-50-50m0 90.9c-22.6 0-40.9-18.3-40.9-40.9s18.3-40.9 40.9-40.9 40.9 18.3 40.9 40.9-18.3 40.9-40.9 40.9",
    style: {
      strokeWidth: 0,
      fill: "url(#schedule_send_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.5 148.1v-20.8c0-2.5-2-4.5-4.5-4.5s-4.5 2-4.5 4.5V150c0 1.2.5 2.4 1.3 3.2l9.1 9.1c1.8 1.7 4.7 1.7 6.4-.1s1.7-4.6 0-6.3z",
    style: {
      strokeWidth: 0,
      fill: "url(#schedule_send_svg2__h)"
    }
  }));
};
export default SvgScheduleSend;